import React from 'react';
import styles from './TestimonialsSection.module.css';

const avatar1 = "https://i.pravatar.cc/150?img=47";
const avatar2 = "https://i.pravatar.cc/150?img=11";
const avatar3 = "https://i.pravatar.cc/150?img=32";

const TESTIMONIALS = [
{
id: 1,
name: "A PAWAR",
text: '"The food was outstanding, the beer was amazing, and the ambience was unbelievable. The vibe was just right for our office dinner party."',
rating: 5,
},
{
id: 2,
name: "ANVITA AGRAWAL",
text: '"The rooftop setup is super chill and perfect for hanging out with friends. Their strawberry cider is amazing and definitely my new favorite."',
rating: 5,
},
{
id: 3,
name: "NEHA BALODA",
text: '"Loved the vibes! The live music is just too good, the beers are freshly brewed, and everything we ordered was delicious."',
rating: 5,
},
{
id: 4,
name: "AMIT CHAUBAL",
text: '"The food was outstanding and the beers are unlike anything I have had before. The Ragi IPA is easily one of the best IPAs in Pune."',
rating: 5,
},
{
id: 5,
name: "RUTUJ SURANA",
text: '"One of Pune’s most beautifully curated dining spaces. The cuisine is refined, the craft beers are exceptionally smooth, and the ambience is outstanding."',
rating: 5,
},
{
id: 6,
name: "POONAM",
text: '"The brewery is amazing, especially the Strawberry Beer, Apple Cider, and Guava Beer. Delicious food, great service, and an overall fantastic experience."',
rating: 5,
},
];


const StarRating = ({ count }) => (
  <div className={styles.starsContainer} aria-label={`${count} out of 5 stars`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <span key={i} className={i < count ? styles.starFilled : styles.starEmpty}>★</span>
    ))}
  </div>
);

const Card = ({ t }) => (
  <div className={styles.card} aria-label={`Testimonial by ${t.name}`}>
    {/* <img src={t.avatar} alt={t.name} className={styles.avatar} /> */}
    <StarRating count={t.rating} />
    <blockquote className={styles.quoteText}>{t.text}</blockquote>
    <div className={styles.separator} />
    <h4 className={styles.authorName}>{t.name}</h4>
  </div>
);

const TestimonialsSection = () => {
  const cards = [...TESTIMONIALS, ...TESTIMONIALS, ...TESTIMONIALS];

  return (
    <section className={styles.sectionContainer}>
      <p className={styles.sectionLabel}>What Our Guests Say</p>

      <div className={styles.trackOuter}>
        <div className={styles.trackInner}>
          {cards.map((t, i) => (
            <Card key={`${t.id}-${i}`} t={t} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;